import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { APP_ROUTES } from '../shared/config/routes-config';
import { RouteConfig } from '../shared/interfaces/routes-config.interface';
import { TicketsQueueContainer } from './containers/tickets-queue/tickets-queue.container';
import { TicketDetailsContainer } from './containers/ticket-details/ticket-details.container';

/**
 * The agent workspace (Trello #244): the queue and one ticket's thread. Zammad
 * runs headless behind server.integrator.helpdesk, so this module is where staff
 * actually work tickets. When the inbox channels arrive, they arrive here too: a
 * conversation is a ticket with a channel, not a second inbox.
 */
export const TicketsModule: React.FC = () => {
  // Read at render time, never in a module-level const: see lead.module.tsx.
  const children = APP_ROUTES.TICKETS_MODULE.CHILDREN as RouteConfig;

  return (
    <>
      <Route exact path={APP_ROUTES.TICKETS_MODULE.FULL_PATH}>
        <Redirect to={children.QUEUE.FULL_PATH} />
      </Route>
      <Route path={children.DETAILS.FULL_PATH} component={TicketDetailsContainer} />
      <Route exact path={children.QUEUE.FULL_PATH} component={TicketsQueueContainer} />
    </>
  );
};
